/* global axios */
import ApiClient from './ApiClient';

class ExecutiveReportsAPI extends ApiClient {
  constructor() {
    super('executive_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getExecutiveMetrics({ since }) {
    return axios.get(`${this.url}`, {
      params: { since },
    });
  }

  getContactAnalytics({ since }) {
    return axios.get(`${this.url}/contact_analytics`, {
      params: { since },
    });
  }

  getSentimentAnalytics({ since }) {
    return axios.get(`${this.url}/sentiment_analytics`, {
      params: { since },
    });
  }

  getOperationalAnalytics({ since }) {
    return axios.get(`${this.url}/operational_analytics`, {
      params: { since },
    });
  }
}

export default new ExecutiveReportsAPI();
